import styled from 'styled-components';

export const RadioGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 25px;
`;

export const RadioGroupItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const RadioGroupLabel = styled.label`
    cursor: pointer;
    font-size: 1.25rem;
    font-weight: 400;
`;

export const RadioGroupInput = styled.input`
    cursor: pointer;
    width: 16px;
    height: 16px;
`;

export const SubmitButton = styled.button`
    cursor: pointer;
    // padding: 5px 10px;
    background-color: #4CAF50;
    color: white;
    margin-top: 25px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
`;